import { resourceState, resourceMutations } from '@/store/utils/resource';
import { CONTACT_LISTS } from '@/store/entities/schema_types';
import { accountContactListClient as service } from '@/api/clients';

export default {
  namespaced: true,
  state: resourceState(),
  mutations: resourceMutations,
  actions: {
    async load(ctx, { accountId, params = {} }) {
      try {
        const response = await service.list(accountId, { params });
        const { data, meta, links } = response.data;
        const contactListIds = await ctx.dispatch('persist', { type: CONTACT_LISTS, data });
        ctx.commit('setIds', contactListIds);
        ctx.commit('setMeta', meta);
        ctx.commit('setLinks', links);
        return Promise.resolve({
          contactListIds,
          meta,
          links,
        });
      } catch (error) {
        const { response } = error;
        return Promise.reject(response);
      }
    },

    async store(ctx, { accountId, formData = {} }) {
      try {
        const response = await service.store(accountId, formData);
        const { data } = response.data;
        const contactListId = await ctx.dispatch('persist', { type: CONTACT_LISTS, data });
        return Promise.resolve({ contactListId });
      } catch (error) {
        const { response } = error;
        return Promise.reject(response);
      }
    },
    persist(ctx, { type, data }) {
      return ctx.dispatch(
        'entities/persistEntities',
        {
          type,
          data,
        },
        { root: true }
      );
    },
  },
  getters: {
    contactLists({ ids }, getters, { entities }) {
      return ids.map((id) => entities.contactLists.byId[id]);
    },
    contactList({ current }, getters, { entities }) {
      if (!current) return null;
      return entities.contactLists.byId[current] || null;
    },
  },
};
